import './WithdrawalCancelModalStyle.scss';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { formatDateToSlashDateTime } from 'views/utils/format/FormatDate';
import { formatNumber } from 'views/utils/format/FormatNumber';
import { AssetInfo } from '../Atoms/AssetIInfo';

type WithdrawalCancelModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  withdrawAmount: number | undefined;
  withdrawDate: string | undefined;
  commission: number | undefined;
  transferAmount: number | undefined;
  onConfirm: () => void;
  disabled?: boolean;
};

const formatAssetAmount = (amount: number | undefined) => (amount === undefined ? '-' : formatNumber(amount));

export const WithdrawalCancelModal = (props: WithdrawalCancelModalProps) => {
  const { isOpen, onRequestClose, withdrawAmount, withdrawDate, onConfirm, disabled } = props;

  return (
    <ModalBase
      isOpen={isOpen}
      modalStyle={ModalStyle.confirmModal}
      onRequestClose={onRequestClose}
      children={
        <div className="withdrawalCancel">
          <div className="withdrawalCancel_header">出金予約取消</div>
          <div className="withdrawalCancel_reservation">
            <AssetInfo label="取消対象出金予約受付金額" amount={formatAssetAmount(withdrawAmount)} />
            <div className="withdrawalCancel_reservationDate">({formatDateToSlashDateTime(withdrawDate, false)})</div>
          </div>
          <div className="withdrawalCancel_message">
            <div>＜ご注意＞</div>
            <div>・出金予約の取消は毎週木曜日12時締め切ります</div>
            <div>・出金確定後の取消は行えませんのでご注意下さい</div>
            <div>・出金に伴う手数料はお客様負担となりますのであらかじめご了承ください</div>
            <div>※出金手数料は一律440円です</div>
          </div>
          <div className="withdrawalCancel_actions">
            <Button
              label="出金予約を取り消す"
              buttonSize={ButtonSize.sizeM}
              fillType={FillType.primaryFill}
              onClick={onConfirm}
              disabled={disabled}
            />
            <Button
              label="戻る"
              buttonSize={ButtonSize.sizeM}
              fillType={FillType.primaryEmpty}
              onClick={onRequestClose}
              disabled={disabled}
            />
          </div>
        </div>
      }
    />
  );
};
